<script lang="ts">
import { h, defineComponent, type VNode } from 'vue';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

export default defineComponent({
  name: 'PublishedToWebChip',

  render (): VNode {
    return h(CommonChip, { color: 'primary' }, { default: () => [
      h('span', 'Published to web')
    ] });
  }
})
</script>
